  export const setJobsFilterAction = filter => ({
    type: "JOBS_SET_FILTER",
    payload: filter
  });
  
  export const setJobsSkillFilterAction = filter => ({
    type: "JOBS_SET_SKILL_FILTER",
    payload: filter
  });
